import { FileData, FileStatus } from '../types'

export default class FileTypeFabric {
  create(
    data: {
      name: string
      status: FileStatus
      preview: string | ArrayBuffer | null
      // eslint-disable-next-line id-blacklist
      file?: File
      descriptor?: string
    },
  ): FileData {
    const fileData: any = {
      name: data.name,
      status: data.status,
      preview: data.preview,
    }

    if (data.file) {
      // eslint-disable-next-line id-blacklist
      fileData.file = data.file
    }

    if (data.descriptor) {
      fileData.descriptor = data.descriptor
    }

    return fileData
  }

  // eslint-disable-next-line id-blacklist
  createFromFile(file: File): FileData {
    return this.create({
      // eslint-disable-next-line id-blacklist
      name: file.name,
      preview: null,
      status: FileStatus.Uploaded,
      // eslint-disable-next-line id-blacklist
      file,
    })
  }
}
